<template>
  <div style="margin-top: 20px">
    <div class="itemtitle">{{ $t('lang.applyList.electronicReceiptFile') }}</div>
    <div class="filelist">
      <el-row class="rowheader">
        <el-col :span="12" style="text-align: center; padding-left: 15px">{{ $t('lang.applyList.receiptTitle') }}</el-col>
        <el-col :span="12" style="text-align: center">{{ $t('lang.applyList.receiptFileName') }}</el-col>
      </el-row>
      <el-row class="filerow">
        <el-col :span="12" style="text-align: center; padding-left: 15px">
          {{ this.applyVo.receiptTitle }}
        </el-col>
        <el-col :span="12" style="text-align: center">
          <template v-if="this.applyVo.scannedReceiptFile">
            <el-button size="mini" type="text" @click="download">{{ this.applyVo.scannedReceiptFile.fileName }}
              <i class="icon iconfont icon-xiangxiajiantou-s"></i>
            </el-button>
          </template>
<!--          <el-button type="info"
                     size="mini"
                     v-if="this.applyVo.scannedReceiptFile"
                     @click="downloadReceipt">
            {{
              this.applyVo.scannedReceiptFile.fileName
            }}
            <i class="icon iconfont icon-xiangxiajiantou-s" style="color: #a2100e"></i>
          </el-button>-->
          <template v-else>
            {{ $t('lang.applyList.receiptFileNotUpload') }}
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/api/base'

export default {
  name: 'ElectronicReceiptFile',
  props: {
    applyVo: {
      type: Object
    }
  },
  methods: {
    download () {
      downloadFile(this.applyVo.scannedReceiptFile)
    }
  }
}
</script>

<style scoped>
.itemtitle {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}
.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}
.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
  color:#707070;
}
.filelist .filerow:nth-child(even){
  background: #ededed;
}
/deep/ .el-button--text {
  color: #606266;
}
/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;
}
/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}
</style>
